module.exports = __webpack_public_path__ + "static/media/crown.27ab2851.jpg";